import { render, staticRenderFns } from "./product-lexmark.vue?vue&type=template&id=79406cd0&"
import script from "./product-lexmark.vue?vue&type=script&lang=js&"
export * from "./product-lexmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports